export const cpfJustNumbers = (cpf: string): string => {
  const formattedCpf = cpf.replace(/[^0-9a-zA-Z]+/gm, '');

  return formattedCpf;
};
